// src/components/VirtualIDCard.js
import React, { useRef, useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Button,
  Paper,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const VirtualIDCard = ({data}) => {

  const idCardRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  // Updated data for the ID card
  const userData = {
    name: 'MOHD ARIF',
    position: 'Student',
    phone: '+91 9838827581',
    idNo: 'ID1234567890',
    Course: 'ADCA',
    photo: 'https://example.com/photo.jpg', // Replace with the actual URL or file path of the photo
    organization: 'Muskan Institute Of Technology',
  };

  const handleDownload = () => {
    setIsLoading(true);
    const input = idCardRef.current;
    html2canvas(input, { scale: 2, useCORS: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'px',
          format: [canvas.width, canvas.height],
        });
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        pdf.save('virtual-id-card.pdf');
        setIsLoading(false);
        setOpenSnackbar(true);
      })
      .catch((err) => {
        console.error('Failed to generate PDF', err);
        setIsLoading(false);
      });
  };

  const handleShare = () => {
    const input = idCardRef.current;
    html2canvas(input, { scale: 2, useCORS: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'px',
          format: [canvas.width, canvas.height],
        });
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        
        // Save the PDF as a Blob
        const pdfBlob = pdf.output('blob');

        // Use navigator.share to share
        if (navigator.share) {
          const file = new File([pdfBlob], 'virtual-id-card.pdf', { type: 'application/pdf' });
          navigator.share({
            title: 'Virtual ID Card',
            text: 'Here is my virtual ID card!',
            files: [file],
          }).then(() => {
    
          }).catch((error) => {
            console.error('Sharing failed', error);
          });
        } else {
          alert("Your browser doesn't support the sharing feature.");
        }
      })
      .catch((err) => {
        console.error('Failed to generate PDF for sharing', err);
      });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Virtual ID Card
      </Typography>

      {/* ID Card Layout */}
      <Paper
        ref={idCardRef}
        elevation={3}
        sx={{
          width: '260px',
          padding: '16px',
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          position: 'relative',
          textAlign: 'center',
          border: '1px solid #E0E0E0', // Light border for a professional look
        }}
      >
        {/* Top Header */}
        <Box sx={{ backgroundColor: '#0e2f53', padding: '12px 0', borderRadius: '8px 8px 0 0' }}>
          <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 'bold', fontSize: '1.1rem' }}>
            {data?.organizationName}
          </Typography>
        </Box>

        {/* Profile Picture */}
        <Box sx={{ position: 'relative', mt: 3 }}>
          <Avatar
            src={userData.photo}
            sx={{
              width: 120,
              height: 120,
              margin: '0 auto 20px',
              border: '5px solid #00274d',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Box>

        {/* User Information */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2C3E50', fontSize: '1.2rem'}}>
            {data.firstName} {data.lastName}
          </Typography>
          <Typography variant="body1" sx={{ color: '#6C757D', mb: 1 }}>
            {userData?.position}
          </Typography>

          {/* Contact Details */}
          <Box
            sx={{
              backgroundColor: '#F8F9FA',
              padding: '8px',
              borderRadius: '8px',
              textAlign: 'left',
              border: '1px solid #E9ECEF',
            }}
          >
            <Typography variant="body2" sx={{ color: '#495057', fontSize: '0.9rem' }}>
              <strong>Course:</strong> {data.courseName}
            </Typography>
            <Typography variant="body2" sx={{ color: '#495057', fontSize: '0.9rem' }}>
              <strong>Phone:</strong> {data.phone}
            </Typography>
            <Typography variant="body2" sx={{ color: '#495057', fontSize: '0.9rem' }}>
              <strong>ID No:</strong> {data._id}
            </Typography>
          </Box>
        </Box>

        {/* Bottom Accent Bar */}
        <Box sx={{ height: '60px', backgroundColor: '#0e2f53', borderRadius: '0 0 12px 12px', color: 'white', p: 1 }}>
         {data?.organizationAddress.street} {data?.organizationAddress.city} {data.organizationAddress.state} {data.organizationAddress.zip} {data.organizationAddress.country} 
        </Box>
      </Paper>

      {/* Download and Share Buttons */}
      {isLoading ? (
        <CircularProgress sx={{ mt: 3 }} />
      ) : (
        <>
          <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={handleDownload}>
            Download ID Card
          </Button>
          <Button variant="contained" color="secondary" sx={{ mt: 3, ml: 2 }} onClick={handleShare}>
            Share
          </Button>
        </>
      )}

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          ID Card downloaded successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VirtualIDCard;
